module.exports = __webpack_public_path__ + "static/img/remark-market.d54d0b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/remark-market.png
// module id = +yxU
// module chunks = 1